import { render, staticRenderFns } from "./RequireNewPassword.vue?vue&type=template&id=5a74b3e7&scoped=true&"
import script from "./RequireNewPassword.vue?vue&type=script&lang=ts&"
export * from "./RequireNewPassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a74b3e7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
